import React from 'react';
import './section8.css';
import imagemGrande from '../../assets/parceiros/Parceiro10.svg';

const Section8 = () => {
  return (
    <section className="section8">
      <h1 className="section8-title">PARCEIROS CONFIRMADOS</h1>
        <p>GRANDES NOMES DA INDÚSTRIA, DISTRIBUIÇÃO E SERVIÇO <br/> COM CONDIÇÕES COMERCIAIS IMPERDÍVEIS</p>
      <img
        src={imagemGrande}
        alt="Descrição da imagem grande"
        className="section8-image"
      />
    </section>
  );
};

export default Section8;
